/**
 * Подсказка «как делать правильно» — то, что открывается кнопкой «?».
 *
 * Открывается ПОВЕРХ тренировки, а не вместо неё: уходя на другой экран,
 * человек теряет из виду записанные подходы и текущий вес, а вернувшись —
 * заново ищет, где остановился. Здесь же достаточно закрыть карточку.
 *
 * Картинок может не быть (в свободных источниках есть не всё), связи в зале
 * тоже может не быть. Текст в обоих случаях остаётся: он едет вместе со
 * сборкой. Не загрузившаяся картинка убирается совсем — рамка с крестиком
 * вместо рисунка выглядит как поломка приложения.
 */

import { useState } from 'react'

import { TECHNIQUE, TECHNIQUE_IMAGES, TECHNIQUE_LICENSE } from '../technique'

/** Есть ли вообще что показать по этому движению. */
export function hasTechnique(exerciseId: number): boolean {
  return exerciseId in TECHNIQUE
}

function Frames({ exerciseId, name }: { exerciseId: number; name: string }) {
  const images = TECHNIQUE_IMAGES[exerciseId]
  const [broken, setBroken] = useState(false)

  if (!images || broken) return null

  return (
    <>
      <div className="tq-frames">
        {images.frames.map((file) => (
          <img
            key={file}
            className="tq-frame"
            src={`/technique/${file}`}
            alt={`${name}: одно из крайних положений движения`}
            loading="lazy"
            onError={() => setBroken(true)}
          />
        ))}
      </div>
      {/* Подписи «начало» и «конец» тут были бы неправдой: в исходном наборе
          кадры пронумерованы, но не упорядочены. У становой тяги под первым
          номером лежит верхняя точка, у жима — нижняя. Пара показывает два
          крайних положения, а что из них старт, говорит текст ниже. */}
      <div className="faint tq-frames-hint">Два крайних положения движения</div>
      {images.note && <div className="tq-note">{images.note}</div>}
    </>
  )
}

function Block({ title, items }: { title: string; items: string[] }) {
  return (
    <div className="tq-block">
      <div className="tq-title">{title}</div>
      <ul className="tq-list">
        {items.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </div>
  )
}

export default function TechniqueCard({
  exerciseId,
  name,
  onClose,
}: {
  exerciseId: number
  name: string
  onClose: () => void
}) {
  const technique = TECHNIQUE[exerciseId]
  if (!technique) return null

  const images = TECHNIQUE_IMAGES[exerciseId]

  return (
    <div className="card tight tq-card">
      <div className="row between">
        <b>{name}: как делать</b>
        <button className="btn ghost" onClick={onClose}>
          Закрыть
        </button>
      </div>

      <Frames exerciseId={exerciseId} name={name} />

      <Block title="Подготовка" items={technique.setup} />
      <Block title="Движение" items={technique.execution} />
      <Block title="Частые ошибки" items={technique.mistakes} />

      {images && (
        // Атрибуция обязательна по лицензии CC BY-SA и стоит на виду, а не
        // мелким шрифтом: рисунки чужие, и это единственная плата за них.
        <div className="faint tq-credit">
          Рисунки: {TECHNIQUE_LICENSE.author},{' '}
          <a href={TECHNIQUE_LICENSE.licenseUrl} target="_blank" rel="noreferrer noopener">
            {TECHNIQUE_LICENSE.license}
          </a>
          {images.sources.map((url, index) => (
            <span key={url}>
              {' · '}
              <a href={url} target="_blank" rel="noreferrer noopener">
                источник {index + 1}
              </a>
            </span>
          ))}
        </div>
      )}
    </div>
  )
}
